import React from 'react';
import {
    ProgressComponent,
    Progress,
    ProgressBar,
    ProgressTrack,
    Title,
} from './style';

const BriefingProgress = ({ step, channel, totalSteps }) => {
    const stepNames = {
        1: 'Objetivo',
        2: 'Localização',
        3: 'Logo',
        4: 'Investimento',
        5: 'Site',
        6: 'Acesso',
        7: 'Contratação',
        8: 'Campanha configurada com sucesso.',
    };

    const stepGoogleNames = {
        1: stepNames[1],
        2: stepNames[2],
        3: stepNames[3],
        4: stepNames[4],
        5: stepNames[5],
        6: stepNames[7],
        7: stepNames[8],
    };

    const currentSteps = channel === 'google' ? stepGoogleNames : stepNames;

    return (
	<ProgressComponent>
		<Title>{currentSteps[step]}</Title>
		<Progress>
			<ProgressTrack />
			<ProgressBar step={step} totalSteps={totalSteps} />
		</Progress>
	</ProgressComponent>
    );
};


export default BriefingProgress;
